<!--  -->
<template>
 <div class="home">
    <div>首页</div>
    <div @click="toDownload">去下载页</div>
    <div @click="toCollege">去钱收收学院</div>
    <div @click="toDetail">去商品详情</div>
    <div @click="toPrivacyPolicy">去隐私政策</div>
    <div @click="toUserAgreement">去用户协议</div>
    <div @click="toTakeOut">外卖优惠</div>
    <div @click="toInstructions">比价说明</div>
    <div @click="toQRCode">二维码详情</div>
    <div @click="toProductDetail">打开商品</div>
    <div @click="openApp">打开app</div>
    <div @click="close">关闭浏览器</div>
    <div @click="openUrlWithAliPay">通过支付宝打开指定链接</div>
    <div @click="openUrlWithWeChat">打开微信</div>
    <div @click="toShopDownload">商城下载</div>
    <div @click="toMYGPrivacyPolicy">去麦芽GO隐私政策</div>
    <div @click="toHBMPrivacyPolicy">去黑白马隐私政策</div>
 </div>
</template>

<script>


export default {
  data () {
    return {

    }
  },
  methods: {
    toDownload() {
      this.$router.push({
        path: '/h5/download/app',
        query: {
          code: '21169608',
          userNumber: '162849036971185051'
        }
      })
    },
    toShopDownload() {
      this.$router.push({
        path: '/h5/shopdownload/app',
        query: {
          inviteCode: '21170520',
          appNo:"165396018882187332"
        }
      })
    },

    toCollege() {
      this.$router.push({
        path: '/h5/college',
      })
    },
    toDetail() {
      this.$router.push({
        path: '/h5/goodsDetail',
        query: {
          itemId: 610981904014,
          allianceType: 0,
          inviteCode: 857108,
          type: 1
        }
      })
    },
    //通过支付宝打开指定链接
    openUrlWithAliPay() {
      window.location.href = 'alipays://platformapi/startapp?appId=20000067&url=http://www.baidu.com'
    },
    openUrlWithWeChat() {
      // window.location.href = 'weixin://dl/businessWebview/link/?appid=wxc64f8cfed49cc3c3&url=http://www.baidu.com'
      window.location.href = 'weixin://'
    },
    toPrivacyPolicy() {
      this.$router.push({
        path: '/h5/agreement/privacyPolicy',
      })
    },
    toMYGPrivacyPolicy() {
      this.$router.push({
        path: '/h5/agreement/maiYaGO/privacyPolicy',
      })
    },
    toHBMPrivacyPolicy() {
      this.$router.push({
        path: '/h5/agreement/heiBaiMa/privacyPolicy',
      })
    },
    toUserAgreement() {
      this.$router.push({
        path: '/h5/agreement/userAgreement',
      })
    },
    toTakeOut() {
      this.$router.push({
        path: '/h5/take-out',
        query: {
          inviteCode: 857108,
          type: 0
        }
      })
    },
    toInstructions() {
      this.$router.push({
        path: '/h5/instructions',
      })
    },
    toQRCode() {
      this.$router.push({
        path: '/ql/164276093884524199',
      })
    },
    toProductDetail(){
      this.$router.push({
        path: '/qssProductDetail',
        query: {
          productNo: '164059974894330646',
        }
      })
    },
    openApp() {
      // window.location = 'qss://open/page?path=pages/shopping/goods-detail?allianceType=0&itemId=42819512921'
      window.location = 'qss://'

    },
    close() {
      // window.close()
      console.log(window.wx)

      // this.closeWebPage()
    },
    closeWebPage() {
      if (navigator.userAgent.indexOf("MSIE") > 0) {
        if (navigator.userAgent.indexOf("MSIE 6.0") > 0) {
          window.opener = null; window.close();
        }
        else {
          window.open('', '_top'); window.top.close();
        }
      } else if (navigator.userAgent.indexOf("Firefox") > 0) {
          window.location.href = 'about:blank '; //火狐默认状态非window.open的页面window.close是无效的
      } else {
        window.opener = null;
        window.open('', '_self', '');
        window.close();
      }
    }
  }
}

</script>
<style lang='less' scoped>
.home {
  font-size: 28px;
}
.name {
  color: #222;
}
</style>
